import { useState } from "react";
import { useUpdateVariant } from "../../../../../api/recipeSimulator";
import { RecipeVariantColumn } from "../recipeVariantTable.types";

const VARIANT_NAME_MAX_LENGTH = 15;

interface UseVariantNameInlineEditOptions {
  recipeId: string;
  variants: Array<{ _id?: string; variantName?: string }>;
  readOnly?: boolean;
  onSuccess?: () => void;
}

export const useVariantNameInlineEdit = ({
  recipeId,
  variants,
  readOnly = false,
  onSuccess
}: UseVariantNameInlineEditOptions) => {
  const [editingVariantId, setEditingVariantId] = useState<string | null>(null);
  const [editNameValue, setEditNameValue] = useState("");
  const { mutate: updateVariant, isLoading: isSaving } = useUpdateVariant();

  const startEdit = (column: RecipeVariantColumn) => {
    if (readOnly || !column.variantId) {
      return;
    }

    setEditingVariantId(column.variantId);
    setEditNameValue(column.title);
  };

  const cancelEdit = () => {
    setEditingVariantId(null);
    setEditNameValue("");
  };

  const saveEdit = (variantId: string) => {
    const trimmedName = editNameValue.trim();

    if (!trimmedName || trimmedName.length > VARIANT_NAME_MAX_LENGTH) {
      return;
    }

    const variant = variants.find(item => item._id === variantId);

    if (!variant) {
      return;
    }

    updateVariant(
      {
        recipeId,
        variantId,
        variant: {
          ...variant,
          variantName: trimmedName
        }
      },
      {
        onSuccess: async () => {
          await onSuccess?.();
          cancelEdit();
        }
      }
    );
  };

  return {
    editingVariantId,
    editNameValue,
    setEditNameValue,
    startEdit,
    cancelEdit,
    saveEdit,
    isSaving,
    variantNameMaxLength: VARIANT_NAME_MAX_LENGTH
  };
};
